import { render } from "./HormoneReplacementContentEs.vue?vue&type=template&id=20f776e4"
import script from "./HormoneReplacementContentEs.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__